import { RootStore } from ".";
import { observable, action, runInAction } from "mobx";
import { fetchWrapper } from "../common/Fetch";
import { SuccessableResult } from "../common/BaseClasses";
import { NotificationLevel } from "./NotificationStore";


export interface KassaInfo {
    deviceId: string;
    name: string;
    isActive: boolean;
    isDefault: boolean;
}

export interface KassaDetailsInfo {
    deviceInfo: KassaDeviceInfo;
    shiftStatus: KassaShiftStatus;
    deviceStatus: KassaDeviceStatus;

}

interface KassaDeviceInfo {
    firmwareVersion: string;
    appVersion: string;
    boolVersion: string;
    scriptsVersion: string;
    scriptsName: string;
    model: number;
    modelName: string;
    receiptLineLength: number;
    receiptLineLengthPix: number;
    serial: string;
    ffdVersion: number;
    fnFfdVersion: number;
}

interface KassaShiftStatus {
    state: string,
    number: number,
    expiredAt: Date
}

interface KassaDeviceStatus {
    currentDateTime: Date,
    shift: string,
    blocked: boolean,
    coverOpened: boolean,
    paperPresent: boolean,
    fiscal: boolean,
    fnFiscal: boolean,
    fnPresent: boolean,
    cashDrawerOpened: boolean
}

export class KassesStore {



    _rootStore: RootStore;

    @observable kasses: KassaInfo[] = [];
    @observable kassaDetails?: KassaDetailsInfo;


    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @action
    loadKasses() {
        this.kasses = [];

        fetchWrapper(`api/kasses/kasseslist`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<KassaInfo[]>)
            .then(result => {
                runInAction("fetch complete loadKasses", () => {
                    this.kasses = result;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    loadKassaDetails(deviceId: string) {
        this.kassaDetails = undefined;
        fetchWrapper(`api/kasses/details/${deviceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<KassaDetailsInfo>)
            .then(result => {
                runInAction("fetch complete loadKassaDetails", () => {
                    this.kassaDetails = result;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    closeShift(deviceId: string) {
        fetchWrapper(`api/kasses/closeShift/${deviceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<SuccessableResult<any>>)
            .then(result => {
                runInAction("fetch complete closeShift", () => {
                    if (result.isSuccess)
                        this._rootStore.notificationStore.addNotification("Запрос на закрытие смены отправлен на кассу", NotificationLevel.success);
                    else {
                        this._rootStore.notificationStore.addNotification("При отправке запроса на закрытие смены возникла ошибка. " + result.errorMessage, NotificationLevel.error);
                    }
                });
            })
            .catch(res => {
                console.log(res);
            });
    }
}